import { render, staticRenderFns } from "./AnimatedClockIcon.vue?vue&type=template&id=2e6ed51a&"
import script from "./AnimatedClockIcon.vue?vue&type=script&lang=ts&"
export * from "./AnimatedClockIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports